// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"dac4869d","2748":"7ce7e52e","5257":"6fa6ee63","7834":"c3ac3780","9480":"c3ac3780"}[chunkId] + ".chunk.css";
};